module.exports = __webpack_public_path__ + "static/media/step1_m.9b244285.png";